module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="792" height="792" viewBox="0 0 792 792"><path d="M580.802 369.604L211.198 0l-26.396 26.396L554.405 396 184.802 765.604 211.198 792l396-396z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icons/right-arrow-angle.svg
// module id = 666
// module chunks = 1